export default __webpack_public_path__ + "static/media/c_1.3e1baeed.jpg";